/**
 * Sorts an array of options alphabetically by their label property.
 *
 * This utility function is designed to sort dropdown options and other
 * selection lists where each item has a 'label' property.
 * The sorting is case-insensitive and does not modify the original array.
 *
 * @param options - Array of objects with at least a 'label' property
 * @returns A new sorted array of options
 *
 * @example
 * ```typescript
 * const sortedOptions = sortOptionsByLabel([
 *   { label: "Zebra", value: "zebra" },
 *   { label: "Apple", value: "apple" }
 * ]);
 * // Result: [{ label: "Apple", value: "apple" }, { label: "Zebra", value: "zebra" }]
 * ```
 */
export function sortOptionsByLabel<T extends { label: string }>(options: Array<T>): Array<T> {
  return [...options].sort((a, b) => a.label.localeCompare(b.label, undefined, { sensitivity: "base" }));
}
